import { render } from "./UserForgotPassword.vue?vue&type=template&id=6afe4341"
import script from "./UserForgotPassword.vue?vue&type=script&lang=js"
export * from "./UserForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/projectivegroup/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__